import { ReactElement } from 'react';
import { MedianOrMean } from '@blisspointmedia/bpm-types/dist/MMMUtils';

const CENTRAL_MEASURE_DOT_SIZE = 7;

interface SaturationCentralMeasureDotProps {
  // Injected by Recharts when this element is passed as a Line `dot`.
  cx?: number;
  cy?: number;
  stroke?: string;
  payload?: { name: string; spend: number };
  // Supplied at the call site.
  saturationData: {
    centralMeasures: Record<string, { dataPoint: number } & Record<string, number | null>>;
  };
  centralMeasure: MedianOrMean;
}

// Diamond marker drawn at each series' central-measure (median/mean) spend point on the
// saturation curve — rendered only where the point's spend matches the central measure and
// its value is non-null. Shared by the Brand-Impact and Business-Impact Model Insights
// saturation charts (previously a byte-identical inline copy in each).
export const SaturationCentralMeasureDot = ({
  cx,
  cy,
  stroke,
  payload,
  saturationData,
  centralMeasure
}: SaturationCentralMeasureDotProps): ReactElement | null => {
  if (
    !payload ||
    cx === undefined ||
    cy === undefined ||
    saturationData.centralMeasures[payload.name].dataPoint !== payload.spend ||
    saturationData.centralMeasures[payload.name][centralMeasure.toLowerCase()] === null
  ) {
    return null;
  }

  return (
    <svg>
      <polygon
        points={`${cx},${cy - CENTRAL_MEASURE_DOT_SIZE} ${
          cx + CENTRAL_MEASURE_DOT_SIZE
        },${cy} ${cx},${cy + CENTRAL_MEASURE_DOT_SIZE} ${cx - CENTRAL_MEASURE_DOT_SIZE},${cy}`}
        fill={stroke}
      />
    </svg>
  );
};
